import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

export default ({
  state: {
    loadedVideoIdeas: []
  },
  mutations: {
    createVideoIdeaRating (state, payload) {
      const idea = state.loadedVideoIdeas.find(idea => {
        return idea.id === payload.id
      })
      if (payload.video) {
        idea.video = payload.video
      }
      if (payload.type) {
        idea.type = payload.type
      }
      if (payload.name) {
        idea.name = payload.name
      }
      if (payload.date) {
        idea.date = payload.date
      }
      if (payload.time) {
        idea.time = payload.time
      }
      if (payload.rating) {
        idea.rating = payload.rating
      }
      if (payload.description) {
        idea.description = payload.description
      }
      if (payload.voteCount) {
        idea.voteCount = payload.voteCount
      }
    },
    createVideoIdea (state, payload) {
      state.loadedVideoIdeas.push(payload)
    },
    setLoadedVideoIdeas (state, payload) {
      state.loadedVideoIdeas = payload
    },
    deleteVote (state, payload) {
      for (var i = 0; i < state.loadedVideoIdeas.length; i++) {
        if (state.loadedVideoIdeas[i].id === payload) {
          state.loadedVideoIdeas.splice(i, 1)
        }
      }
    }
  },
  actions: {
    createVideoIdeaRating ({ commit }, payload) {
      commit('setLoading', true)
      const updateObj = {}
      if (payload.video) {
        updateObj.video = payload.video
      }
      if (payload.type) {
        updateObj.type = payload.type
      }
      if (payload.name) {
        updateObj.name = payload.name
      }
      if (payload.date) {
        updateObj.date = payload.date
      }
      if (payload.time) {
        updateObj.time = payload.time
      }
      if (payload.voteCount) {
        updateObj.voteCount = payload.voteCount
      }
      if (payload.description) {
        updateObj.description = payload.description
      }
      if (payload.rating) {
        updateObj.rating = payload.rating
      }
      firebase.database().ref('/video ideas/').child(payload.id).update(updateObj)
        .then(() => {
          commit('setLoading', false)
          commit('createVideoIdeaRating', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    createVideoIdea ({ commit }, payload) {
      const idea = {
        name: payload.name,
        description: payload.description,
        type: payload.type,
        date: payload.date,
        time: payload.time,
        video: payload.video,
        rating: 0,
        voteCount: 0
      }
      firebase.database().ref('video ideas').push(idea)
        .then((data) => {
          console.log(data)
        })
      commit('createVideoIdea', idea)
    },
    loadVideoIdeas ({ commit }) {
      commit('setLoading', true)
      firebase.database().ref('video ideas').once('value')
        .then((data) => {
          const ideas = []
          const obj = data.val()
          for (const key in obj) {
            ideas.push({
              id: key,
              name: obj[key].name,
              description: obj[key].description,
              type: obj[key].type,
              date: obj[key].date,
              time: obj[key].time,
              rating: obj[key].rating,
              voteCount: obj[key].voteCount,
              video: obj[key].video
            })
          }
          commit('setLoading', false)
          commit('setLoadedVideoIdeas', ideas)
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    deleteVote ({ commit }, payload) {
      firebase.database().ref('video ideas').child(payload).remove()
      commit('deleteVote', payload)
    }
  },
  getters: {
    loadedVideoIdeas (state) {
      return state.loadedVideoIdeas.sort((ideaA, ideaB) => {
        return ideaA.date + ideaA.time > ideaB.date + ideaB.time
      })
    },
    loadedVideoIdea (state) {
      return (ideaId) => {
        return state.loadedVideoIdeas.find((idea) => {
          return idea.id === ideaId
        })
      }
    }
  }
})
